// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard .filter {
  position: absolute;
  right: 0px;
  top: 15px;
}

.dashboard .filter .icon {
  color: #aab7cf;
  padding-right: 20px;
  padding-bottom: 5px;
  transition: 0.3s;
  font-size: 16px;
}

.dashboard .filter .icon:hover,
.dashboard .filter .icon:focus {
  color: #4154f1;
}

.dashboard .filter .dropdown-header {
  padding: 8px 15px;
}

.dashboard .filter .dropdown-header h6 {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #aab7cf;
  margin-bottom: 0;
  padding: 0;
}

.dashboard .filter .dropdown-item {
  padding: 8px 15px;
}

.whole {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT","sourcesContent":[".dashboard .filter {\n  position: absolute;\n  right: 0px;\n  top: 15px;\n}\n\n.dashboard .filter .icon {\n  color: #aab7cf;\n  padding-right: 20px;\n  padding-bottom: 5px;\n  transition: 0.3s;\n  font-size: 16px;\n}\n\n.dashboard .filter .icon:hover,\n.dashboard .filter .icon:focus {\n  color: #4154f1;\n}\n\n.dashboard .filter .dropdown-header {\n  padding: 8px 15px;\n}\n\n.dashboard .filter .dropdown-header h6 {\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  color: #aab7cf;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.dashboard .filter .dropdown-item {\n  padding: 8px 15px;\n}\n\n.whole {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
